<app-menu [hasChanges]="loadMenu" title="Consulta Ticket"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 grid align-items-center">
    <div class="col-12 pr-3">
        <div class="">
            <div class="p-inputgroup">
                <span class="p-input-icon-left w-full">
                    <p-inputNumber [(ngModel)]="queryNumber" placeholder="Relacione el número de ticket" class="w-full">
                    </p-inputNumber>
                </span>
                <button pButton icon="pi pi-search" class="p-button p-button-success" (click)="searchNumber()"></button>
            </div>
        </div>
    </div>
</div>
<p-divider></p-divider>
<div class="flex justify-content-center">
    <div class="w-full md:w-6 mx-auto">
        <iframe #queryFrame src="" title="Ticket" width="100%" height="600" style="border: none;">
        </iframe>
    </div>
</div>